<script>
import { mapGetters } from 'vuex'
export default {
  name: 'lemonMessageProduct',
  inheritAttrs: false,
  inject: ['IMUI'],
  render () {
    var product = JSON.parse(this.$attrs.message.content)
    var classname = 'lemon-message lemon-message--status-succeed lemon-message-product'
    var displayName = this.current_user.name
    var avatar = this.current_user.headimgurl
    var url = 'https://www.nmzp.com/#/GoodsDetail?id=' + product.goods_id
    if (this.$attrs.message.fromUser.id === this.current_user.id) {
      classname = 'lemon-message lemon-message--status-succeed lemon-message-product lemon-message--reverse'
      displayName = this.current_user.name
      avatar = this.current_user.headimgurl
    } else {
      displayName = this.$attrs.message.fromUser.displayName
      avatar = this.$attrs.message.fromUser.avatar
    }
    return (
      <div class={classname}>
        <div class="lemon-message__avatar">
          <span class="lemon-avatar" shape="square" style="width: 36px; height: 36px; line-height: 36px; font-size: 18px;">
            <img src={avatar} />
          </span>
        </div>
        <div class="lemon-message__inner">
          <div class="lemon-message__title">
            <span>{displayName}</span>
          </div>
          <div class="lemon-message__content-flex">
            <a href={url} target="_blank" title={product.title}>
              <div class="single-temp send">
                <div class="product-item clearfix">
                  <div class="pic-wrap">
                    <img v-real-img={product.imgpath} src="../../assets/images/zwtp.jpg" alt={product.title} />
                  </div>
                  <div class="info-wrap">
                    <div class="title">
                      <p>{product.title}</p>
                    </div>
                    <div class="label normal"></div>
                    <div class="footer">
                      <div class="info-box">
                        <span class="price">{product.tax_price > 0 ? '¥' + product.tax_price : '询价' }</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <div class="lemon-message__content-after">
            </div>
            <div class="lemon-message__status">
              <i class="lemon-icon-loading lemonani-spin"></i>
              <i title="重发消息" class="lemon-icon-prompt" style="color: rgb(255, 37, 37); cursor: pointer;"></i>
            </div>
          </div>
        </div>
      </div>
    )
  },
  computed: {
    ...mapGetters(['current_user'])
  }
}
</script>
<style>
.single-temp.send {
  float: right;
}
.single-temp {
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  width: 300px;
  padding: 0 20px;
}
.product-item {
  padding: 20px 0;
  cursor: pointer;
}
.pic-wrap {
  float: left;
  width: 80px;
  height: 80px;
}
.pic-wrap img {
  width: 100%;
  height: 100%;
}
.info-wrap {
  width: 165px;
  float: left;
  margin-left: 10px;
}
.info-wrap .title {
  color: #000;
  height: 50px;
  line-height: 1.2;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.info-box {
  font-size: 13px;
  margin-top: 12px;
  color: #999;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/view/service/lemon-message-product.vue